"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rules_api_1 = require("@gamepark/rules-api");
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var MoveUndone_1 = require("../Actions/MoveUndone");
var GameContext_1 = __importDefault(require("../GameProvider/GameContext"));
var ArrayUtil_1 = require("../util/ArrayUtil");
function isUndoOptions(arg) {
    if (typeof arg !== 'object')
        return false;
    var ownPropertyNames = Object.getOwnPropertyNames(arg);
    return ownPropertyNames.length === 1 && ownPropertyNames[0] === 'delayed';
}
function useUndo() {
    var _a;
    var state = react_redux_1.useSelector(function (state) { return state; });
    var Game = (_a = react_1.useContext(GameContext_1.default)) === null || _a === void 0 ? void 0 : _a.RulesView;
    if (!Game)
        throw new Error('Cannot useUndo outside a GameProvider');
    var dispatch = react_redux_1.useDispatch();
    return [function (arg, options) {
            if (isUndoOptions(arg)) {
                dispatch(undo(state, undefined, arg.delayed));
            }
            else {
                dispatch(undo(state, arg, options === null || options === void 0 ? void 0 : options.delayed));
            }
        }, function (move) {
            if (!Game) {
                console.error('A GameContext is required to use canUndo function in useUndo hook');
            }
            return canUndo(Game, state, move);
        }];
}
exports.default = useUndo;
function undo(state, move, delayed) {
    if (!state.actions) {
        return console.error('Cannot undo before actions history is loaded');
    }
    var playerActions = state.actions.filter(function (action) { return action.playerId === state.playerId && !action.cancelled; });
    var actionIndex = move ? playerActions.findIndex(function (action) { return fast_deep_equal_1.default(action.move, move); }) : playerActions.length - 1;
    if (actionIndex === -1) {
        return move ? console.error('Cannot undo: player action history does not contain this move', move)
            : console.error('Cannot undo: player did not play any move yet');
    }
    return MoveUndone_1.moveUndone(actionIndex, delayed);
}
function canUndo(Game, state, move) {
    if (!state.setup || !state.actions) {
        return false;
    }
    var i = ArrayUtil_1.findLastIndex(state.actions, function (action) { return action.playerId === state.playerId && !action.cancelled && (!move || fast_deep_equal_1.default(action.move, move)); });
    var consecutiveActions = state.actions.slice(i + 1).filter(function (action) { return !action.cancelled; });
    var game = new Game(JSON.parse(JSON.stringify(state.setup)));
    rules_api_1.replayActions(game, state.actions.filter(function (action) { return !action.delayed && !action.cancelled; }));
    return i !== -1 && rules_api_1.hasUndo(game) && game.canUndo(state.actions[i], consecutiveActions);
}
//# sourceMappingURL=useUndo.js.map